import utils from '../utils/utils';

// כל הפעולות מול השרת. פעולה חדשה צריכה להופיע גם ב-APP_ACTIONS ב-server/src/routes/ver1Router.ts
export const API = {
  // התחברות (Auth.sql). שתיהן מחזירות [1] token, userId, firstName, lastName
  signUp: (params) => utils.requestData('SignUp', params),   // { firstName, lastName, phone, password, isKfarResident }
  signIn: (phone, password) => utils.requestData('SignIn', { phone, password }),
  signOut: () => utils.requestData('SignOut', {}),

  // sort: 'relevance' | 'diff'. resort=true: שינוי מיון של אותו חיפוש — לא נספר שוב בחיפושים הפופולריים
  searchProducts: (q, sort, resort = false) => utils.requestData('SearchProducts', { q, sort, resort }),
  // כל שמות המוצרים והחברות, להשלמה אוטומטית (נטען פעם אחת, ר' SearchTab.jsx)
  getSearchSuggestions: () => utils.requestData('GetSearchSuggestions', {}),
  // נתוני הדשבורד בעמוד הראשי (ר' Dashboard.jsx)
  getDashboard: () => utils.requestData('GetDashboard', {}),
  // רשימת המוצרים שמאחורי משבצת בדשבורד (ProductListModal.jsx). list: 'compared' | 'cheaper' | 'same' | 'gap'
  // storeId — רק ל-cheaper. page מ-0, 50 בעמוד. אותו מבנה תשובה כמו searchProducts
  getProductList: (list, storeId, q, page) => utils.requestData('GetProductList', { list, storeId, q, page }),
  // רשימת קניות (BasketTab.jsx): items = [{ id, qty }]. מחזיר stores, items, prices — הסכומים מחושבים בקליינט
  compareBasket: (items) => utils.requestData('CompareBasket', { items: items.map((x) => ({ id: x.id, qty: x.qty })) }),
  // "טעינת רשימה" (ImportListDialog.jsx): lines = טקסט חופשי לכל שורה (בלי כמות). מחזיר עד 8 מוצרים לכל שורה,
  // [1] lineIndex, matchRank, id, name, brandName, imageUrl, isWeighable, weight, unitName, storeCount, minPrice
  matchShoppingList: (lines) => utils.requestData('MatchShoppingList', { lines }),
  // עדכון מחיר ע"י משתמש מחובר (spReportPrice). productId = products.id (המוצר בחנות מסוימת — p.productId במחירים)
  // מחזיר [1] productId, price, sitePrice, reportedPrice, reportedAt
  reportPrice: (productId, price) => utils.requestData('ReportPrice', { productId, price }),
  // פידבק: { message, website? (honeypot) }. השם והטלפון נלקחים מהמשתמש המחובר (spAddFeedback)
  sendFeedback: (params) => utils.requestData('AddFeedback', params),

  // ── עמוד הפרופיל (server/src/SQL/Profile.sql) ──
  // [1] firstName, lastName, phone, isKfarResident, registeredAt, lastLogin; [2] favoriteCount, searchCount, priceReportCount, feedbackCount
  getProfile: () => utils.requestData('GetProfile', {}),
  // { firstName, lastName, phone, isKfarResident, password? } — password רק כשמשנים טלפון. מחזיר [1] את הפרטים המעודכנים
  updateProfile: (params) => utils.requestData('UpdateProfile', params),
  // מנתק את כל המכשירים האחרים. [1] signedOutDevices
  changePassword: (currentPassword, newPassword) => utils.requestData('ChangePassword', { currentPassword, newPassword }),
  // מועדפים: ids ל-❤ בכל האתר (favoritesStore.js), והרשימה המלאה עם מחירים (אותו מבנה כמו searchProducts + [4] לא נמכרים)
  getFavoriteIds: () => utils.requestData('GetFavoriteIds', {}),
  setFavorite: (itemId, isFavorite) => utils.requestData('SetFavorite', { itemId, isFavorite }),
  // onlyDrops — רק מועדפים שהוזלו (העמוד הראשי). [5] drops: itemId, storeId, oldPrice, newPrice, changedAt
  getFavorites: (onlyDrops = false) => utils.requestData('GetFavorites', { onlyDrops }),
  // הרשימה שמאחורי מספר בפרופיל (ProfileListModal.jsx). type: 'searches' | 'priceReports' | 'feedback'; page מ-0, 50 בעמוד.
  // [1] totalCount, [2] השורות (ר' spGetMyActivity)
  getMyActivity: (type, page = 0) => utils.requestData('GetMyActivity', { type, page }),

  // ── רשימת הקניות בשרת (server/src/SQL/ShoppingList.sql). כל פעולה שמשנה מחזירה את הרשימה המלאה:
  //    [1] list (id, shareCode, memberCount, isOwner, uTime), [2] members, [3] items (id, qty, name, isWeighable, imageUrl, addedByName)
  getShoppingList: () => utils.requestData('GetShoppingList', {}),
  // mode 'set' — הכמות נקבעת (0 = הסרה); 'add' — מתווספת. items = [{ id, qty }]
  saveShoppingListItems: (mode, items) => utils.requestData('SaveShoppingListItems', { mode, items }),
  addFavoritesToShoppingList: () => utils.requestData('SaveShoppingListItems', { source: 'favorites' }),
  addArchiveToShoppingList: (archiveId) => utils.requestData('SaveShoppingListItems', { source: 'archive', archiveId }),
  // מרוקן ושומר ב"רשימות קודמות"
  clearShoppingList: () => utils.requestData('ClearShoppingList', {}),
  // [1] archives: id, iTime, itemCount, archivedByName; [2] items: archiveId, itemId, qty, name, isWeighable
  getShoppingListHistory: () => utils.requestData('GetShoppingListHistory', {}),
  // [1] shareCode. regenerate — קישור חדש (הישן מפסיק לעבוד)
  shareShoppingList: (regenerate = false) => utils.requestData('ShareShoppingList', { regenerate }),
  // [1] ownerName, memberCount, itemCount, alreadyMember, myItemCount
  getShoppingListInvite: (code) => utils.requestData('GetShoppingListInvite', { code }),
  joinShoppingList: (code) => utils.requestData('JoinShoppingList', { code }),
  leaveShoppingList: () => utils.requestData('LeaveShoppingList', {}),

  // מבצעים (DealsTab.jsx): [1] stores, [2] items (+ discountPct, dealStoreId, totalCount), [3] prices, [4] storeDeals
  getDeals: (storeId, q, page) => utils.requestData('GetDeals', { storeId, q, page }),
};
